import { createAction } from "@reduxjs/toolkit";

const randomScramblePrefix = "random";

export const onRandomScramble = createAction<string>(
  `${randomScramblePrefix}/scramble`
);
